// extracted by mini-css-extract-plugin
module.exports = {"GameOver":"GameOver_GameOver__aWn7F","Dead":"GameOver_Dead__1Ye_H"};